import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ClinicDTO } from '@core/apis/clinic/clinic.dto';
import { StaffApi } from '@core/apis/staff/staff.api';
import { HeaderComponent } from '@core/components/header/header.component';
import { SignInComponent } from '@core/components/sign-in/sign-in.component';
import { SignInDTO } from '@core/dtos/dto';
import { UserTypeEnum } from '@oranta-mis/sdk';
import { ISignIn } from '@core/interfaces/interface';
import { ClinicStore } from '@core/stores/clinic.store';

@Component({
  selector: 'app-clinic-sign-in',
  standalone: true,
  imports: [ReactiveFormsModule, SignInComponent, HeaderComponent],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class ClinicSignInComponent {
  public isLoading: boolean = false;
  public readonly UserTypeEnum = UserTypeEnum;
  private clinic: ClinicDTO | null = null;

  constructor(
    private readonly staffApi: StaffApi,
    private readonly router: Router,
    private readonly clinicStore: ClinicStore,
  ) {
    this.clinic = this.clinicStore.get();
  }

  onSubmit(value: ISignIn) {
    if (!this.clinic) return;
    this.isLoading = true;
    this.staffApi.signIn({ ...value, clinicId: this.clinic.id }).subscribe({
      next: (value: SignInDTO) => {
        this.router.navigate(['/']);
        localStorage.setItem('token', value.token);
      },
      complete: () => {
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
